import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import type { OnboardingSubject } from './onboardingSlice';
import { OnboardingActions } from './onboardingSlice';
import { useAppDispatch } from '../app/redux/useAppSelector';

const SUBJECT = 'onboardingSubject';
const STEP = 'onboardingStep';

export const useReadOnboardingQueryString = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const dispatch = useAppDispatch();

  useEffect(() => {
    const subject = searchParams.get(SUBJECT);
    const stepString = searchParams.get(STEP);
    if (subject && stepString) {
      dispatch(
        OnboardingActions.setOnboardingData({
          subject: subject as OnboardingSubject,
          step: parseInt(stepString, 10),
        }),
      );
      searchParams.delete(SUBJECT);
      searchParams.delete(STEP);
      setSearchParams(searchParams);
    }
  }, [dispatch, setSearchParams, searchParams]);
};

export const getUrlWithOnboardingQueries = (
  subject: OnboardingSubject,
  step: number,
) => {
  const url = new URL(window.location.href);
  url.searchParams.set(SUBJECT, subject);
  url.searchParams.set(STEP, step.toString());

  return `${url.pathname}${url.search}`;
};
